import { CompRef } from '@wix/document-services-types';
import { EditorPointer } from '@wix/editorx-core-api';

import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { GlobalDesignPanelProps, GlobalDesignStyleGroup } from '../../types';

export const rootHostGroupingStrategy = async (
  editorPointer: EditorPointer<CompRef>,
  getHost: GlobalDesignPanelProps<StylesDerivedNativeActionNames>['getHost'],
): Promise<GlobalDesignStyleGroup[]> => {
  const host = await getHost({
    contextBuilder: (builder) => {
      builder.byEditorPointer(editorPointer, (manifest) => {
        builder.withEditorElement(editorPointer, manifest);
      });
    },
  });

  return [
    {
      displayName: '',
      host,
    },
  ];
};
